import { List } from 'immutable';
import { actions } from './actions';
import { mapApiResponse } from './lib';

const initialState = new List();

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.SET:
      return new List(mapApiResponse(value));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/shiftDetails/reducer.js